module.exports = __webpack_public_path__ + "static/media/centralProduct.60bffa3d.jpeg";